import React, { useState } from 'react';

import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { BodyMBold, BodyS } from 'components/Typography/Typography';
import { VisibilityOffOutlined, VisibilityOutlined } from '@material-ui/icons';

import { makeStyles } from '@material-ui/core/styles';
import styles from 'assets/jss/material-dashboard-pro-react/components/paymentMethodsStyle';

import { getPaymentMethodLabels } from 'redux/modules/dynamicLabels/selectors';
import { PASSWORD_SECRET } from 'components/PaymentMethod/constant';

interface BankPaymentDetailsProp {
	mobileNumber?: string;
	bankAliasID?: string;
	variant?: 'minimal' | 'normal';
}

// @ts-ignore
const useStyles = makeStyles(styles);

const PaymentDetails = ({ mobileNumber, bankAliasID, variant = 'normal' }: BankPaymentDetailsProp) => {
	const classes = useStyles();
	const paymentMethodLabels = useSelector(getPaymentMethodLabels);
	const isMinimalVariant = variant === 'minimal';

	const [showPassword, setShowPassword] = useState<boolean>(false);

	const handleClickShowPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		event.preventDefault();
		setShowPassword((passwordShow) => !passwordShow);
	};

	const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
		event?.preventDefault();
	};

	return (
		<>
			<div
				className={classNames(classes.cardDetailsContainer, classes.borderBottomNone, {
					[classes.paddingBottomNone]: isMinimalVariant,
				})}
			>
				<div>
					<BodyS>{paymentMethodLabels?.mobileNumberField}</BodyS>
					<BodyMBold>{mobileNumber}</BodyMBold>
				</div>
			</div>
			<div
				className={classNames(classes.billDetailsContainer, { [classes.paddingBottomNone]: isMinimalVariant })}
			>
				<BodyS>{paymentMethodLabels?.paymentsAliasIDField}</BodyS>
				<div className={classes.bankAliasContainer}>
					<BodyS customClassName={classes.marginBottomNone}>
						{showPassword ? bankAliasID : PASSWORD_SECRET}
					</BodyS>
					<button
						onClick={handleClickShowPassword}
						className={classes.bankAliasToggleButton}
						onMouseDown={handleMouseDownPassword}
					>
						{showPassword ? (
							<VisibilityOffOutlined
								fontSize="small"
								aria-label="visibility-off-icon"
								className={classes.bankAliasEyeIcon}
							/>
						) : (
							<VisibilityOutlined
								fontSize="small"
								aria-label="visibility-on-icon"
								className={classes.bankAliasEyeIcon}
							/>
						)}
					</button>
				</div>
			</div>
		</>
	);
};

export default PaymentDetails;
